import { AxiosResponse } from "axios";
import Vue from "vue";

import dayjs from '@/plugins/dayjs'

import {
  Message
} from 'element-ui'
import { DeepLoop } from "@/common/deepLoop/deepLoop";


export interface StartAndEndTime {
  startTime: string;
  endTime: string;
}

const _toString = Object.prototype.toString;

function isPlainObject(obj: any): boolean {
  return _toString.call(obj).slice(8, -1) === "Object";
}

function extend(to: any, from: any): any {
  if (!to) {
    return from;
  }
  if (!from) return to;

  for (let key in to) {
    to[key] = from[key];
  }

  return to;
}

export class Util {
  public static setListProp<T>(vm: any, list: T[], item: T, key: string, val: any) {
    const existIndex = list.findIndex((eachItem) => eachItem == item);

    if (existIndex > -1) {
      if (item && typeof item == "object" && !Array.isArray(item))
        vm.$set(list[existIndex], key, val);
    }
  }

  public static showFilterText(text: string, isShow: boolean, limit_len: number = 15) {
    if (isShow) {
      return text
    } else {
      return `${text.slice(0, limit_len)}${ limit_len < text.length ? '...' : '' }`
    }
  }


  public clearObject<T>(arg: T): T {
    const newObject: any = {};
    for (const key in arg) {
      if (Object.prototype.toString.call(arg[key]) === "[object Array]") {
        newObject[key] = [];
      } else {
        newObject[key] = "";
      }
    }

    return newObject;
  }

  public getId(id: string | undefined | null): string {
    return id ? id : "";
  }

  public static dateUtil(date: string | undefined | Date): string {
    if (!date) {
      return "";
    }
    const getDate = new Date(date);

    return `${getDate.getFullYear()}-${this.fillZero(
      getDate.getMonth() + 1
    )}-${this.fillZero(getDate.getDate())}`;
  }

  public static fillZero(count: number | string): string {
    return Number(count) < 10 ? "0" + count : String(count);
  }

  public static parseTime(
    time: string | undefined | Date | number,
    cFormat: string
  ): string | null {
    if (arguments.length === 0 || !time) {
      return null;
    }
    let newtimeStr: string = "";
    let newtimeNum: number = 0;
    const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
    let date: Date;

    console.log(time, "time");
    if (time instanceof Date) {
      date = time;
    } else {
      if (typeof time === "string") {
        if (/^[0-9]+$/.test(time)) {
          // support "1548221490638"
          newtimeNum = parseInt(time);
        } else {
          // support safari
          // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
          newtimeStr = time.replace(new RegExp("-", "gm"), "/");
        }
      } else if (typeof time === "number") {
        newtimeNum = time;
      }

      if (newtimeNum.toString().length === 10) {
        newtimeNum = newtimeNum * 1000;
      }

      console.log(newtimeNum, "newtimeNum", newtimeStr, "newtimeStr");
      date = new Date(newtimeNum || newtimeStr);
    }

    console.log(date, "date");
    const formatObj: any = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay(),
    };
    const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
      const value = formatObj[key];
      // Note: getDay() returns 0 on Sunday
      if (key === "a") {
        return ["日", "一", "二", "三", "四", "五", "六"][value];
      }
      return value.toString().padStart(2, "0");
    });
    return time_str;
  }

  public static async sendApi(
    url: string,
    data: any = {},
    options: any,
    success: Function,
    fail: Function
  ) {
    const defaultOptions: RequestInit = {
      // credentials: 'include',
      method: "GET",
      headers: {
        // 'Accept': 'application/json',
        "Content-Type": "application/json",
      },
      mode: "cors",
      cache: "force-cache",
    };

    if (isPlainObject(options)) {
      // 只会覆盖 defaultOptions 存在的key的属性值
      extend(defaultOptions, options);
    }

    if (defaultOptions.method === "GET") {
      // 数据拼接字符串
      let dataStr = "";
      Object.keys(data).forEach((key) => {
        dataStr += key + "=" + data[key] + "&";
      });

      if (dataStr !== "") {
        dataStr = dataStr.slice(0, dataStr.lastIndexOf("&"));
        url = url + "?" + dataStr;
      }
    }

    if ("fetch" in window) {
      try {
        const response = await fetch(url, defaultOptions);
        const responseJson =
          options.repsonseType == "blob"
            ? await response.blob()
            : await response.json();

        success(responseJson);
      } catch (error) {
        // throw new Error(error)
        fail(error);
      }
    } else {
      let requestObj: any;
      if ("XMLHttpRequest" in window) {
        requestObj = new XMLHttpRequest();

        if (options.repsonseType == "blob") {
          requestObj.responseType = "blob";
        }
      }
      // } else {
      //   requestObj = new ActiveXObject()
      // }
      let sendData = "";
      if (defaultOptions.method === "POST") {
        sendData = JSON.stringify(data);
      }

      console.log(url, "url");

      requestObj.open(defaultOptions.method, url, true);
      requestObj.setRequestHeader(
        "Content-type",
        "application/x-www-form-urlencoded"
      );
      requestObj.send(sendData);

      requestObj.onreadystatechange = () => {
        if (requestObj.readyState === 4) {
          if (requestObj.status === 200) {
            let obj = requestObj.response;
            if (typeof obj !== "object") {
              obj = JSON.parse(obj);
            }
            success(obj);
          } else {
            fail(requestObj);
          }
        }
      };
    }
  }

  public static blobFileSaveAs(blob: Blob, filename: string) {
    const navigator: any = window.navigator;
    if ("msSaveOrOpenBlob" in window.navigator) {
      navigator.msSaveBlob(blob, filename);
    } else {
      var link = document.createElement("a");

      var body: any = document.querySelector("body");

      link.href = window.URL.createObjectURL(blob);

      link.download = filename;
      // fix Firefox

      link.style.display = "none";

      body.appendChild(link);

      link.click();

      body.removeChild(link);

      window.URL.revokeObjectURL(link.href);
    }
  }

  public static downloadOtherFlieByNetworkLink(link: string) {
    if (!link) {
      Message.error('无效链接，无法下载文件')
      return
    }
    var aLink = document.createElement("a");

    var body: any = document.querySelector("body");

    // console.log(aLink, 'aLink')
    // console.log(body, 'body')

    // fix Firefox

    aLink.href = link || ''

    aLink.target = '_top'

    aLink.style.display = "none";

    body.appendChild(aLink)

    aLink.click();

    body.removeChild(aLink);
  }

  // 生成封禁时间的所有可选值
  public static getFoibiddenTimeList() {
    const outerList = [];
    const day2second = 24 * 60 * 60;

    for (let i = 1; i <= 7; i++) {
      outerList.push({
        label: `${i}天`,
        value: i * day2second, // 单位秒
      });
    }

    const otherSingleDays = [15, 30];

    for (const count of otherSingleDays) {
      outerList.push({
        label: `${count}天`,
        value: count * day2second, // 单位秒
      });
    }

    return outerList;
  }

  //生成随机数
  public static uuid() {
    var s: any[] = [];
    var hexDigits: string = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
      const startIndex = Math.floor(Math.random() * 0x10);
      s[i] = hexDigits.slice(startIndex, startIndex + 1);
    }
    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    const start19Index = (s[19] & 0x3) | 0x8;
    s[19] = hexDigits.slice(start19Index, start19Index + 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";

    var uuid = s.join("");
    return uuid;
  }

  public static dateTimeUtil(dateTime: string | undefined | Date): string {
    if (!dateTime) {
      return "";
    }
    const date = this.dateUtil(dateTime);
    const getDate = new Date(dateTime);
    return `${date} ${this.fillZero(getDate.getHours())}:${this.fillZero(
      getDate.getMinutes()
    )}:${this.fillZero(getDate.getSeconds())}`;
  }

  public static dateTimeUtilnohms(dateTime: string | undefined | Date): string {
    if (!dateTime) {
      return "";
    }
    const date = this.dateUtil(dateTime);
    console.log(date);
    // const getDate = new Date(dateTime);
    return `${date}`;
  }

  public static getHoursAndMinutes(date: Date): string {
    const time = new Date(date);
    return `${this.fillZero(time.getHours())}:${this.fillZero(
      time.getMinutes()
    )}`;
  }

  // 限制输入数字整数
  public static limitIntegetInput(
    val: string,
    successCb: Function,
    failCb: Function
  ) {
    const reg = new RegExp("[0-9]{1,}", "g");

    let newVal = val.match(reg);

    if (val && Array.isArray(newVal)) {
      successCb(newVal[0] || "");
    } else {
      failCb("");
    }
  }

  // 限制输入带指定小数位数的数字
  public static limitDigitalnput(
    val: string,
    successCb: Function,
    failCb: Function,
    digits: number = 1
  ) {
    const reg = new RegExp(`[0-9]{1,}(\\.)?[0-9]{0,${digits}}`, "g");

    let newVal = val.match(reg);

    if (val && Array.isArray(newVal)) {
      successCb(newVal[0] || "");
    } else {
      failCb("");
    }
  }

  public getUploading(blob: Blob, res: AxiosResponse<Blob> | string): void {
    const data = new Blob([blob], {
      type: "application/vnd.ms-excel;charset=UTF-8",
    });
    const url = URL.createObjectURL(data);
    const link = document.createElement("a");
    link.href = url;
    let fileName;

    if (typeof res === "string") {
      fileName = res;
    } else {
      fileName = res.headers["content-disposition"]
        .split("filename=")[1]
        .split(".")[1];
    }

    link.setAttribute("download", `${new Date().getTime()}.${fileName}`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  public assignObject(form1: any, form2: any) {
    let form: any = form1;
    let otherForm: any = form2;
    for (const i in form) {
      form[i] = otherForm[i];
    }
  }

  public getSexNumber(sex: string): string {
    let result: string = sex;
    if (sex === "男" || sex === "女") {
      if (sex === "男") {
        result = "1";
      } else {
        result = "0";
      }
    }

    return result;
  }

  public static remToPx(rem: number): number {
    const fontSize: number = parseInt(
      <string>document.documentElement.style.fontSize
    );
    return fontSize * rem;
  }

  public static showToast(msg: string, type: string = "yes") {
    if (!sessionStorage.getItem("showToast")) {
      sessionStorage.setItem("showToast", "123");
      const vue = new Vue();
      if (type === "yes") {
        vue.$message.success(msg);
        console.log(msg);
      } else if (type === "warning") {
        vue.$message.warning(msg);
      } else {
        vue.$message.error(msg);
      }

      setTimeout(() => {
        sessionStorage.removeItem("showToast");
      }, 3000);
    }
  }

  public static handleStartTimeAndEndTime(
    time: Date[],
    hours: boolean = true
  ): StartAndEndTime {
    if (!time) {
      return {
        startTime: "",
        endTime: "",
      };
    }
    return hours
      ? {
          startTime: this.dateTimeUtil(time[0]),
          endTime: this.dateTimeUtil(time[1]),
        }
      : { startTime: this.dateUtil(time[0]), endTime: this.dateUtil(time[1]) };
  }

  public static handleStartTimeAndEndTimenohms(
    time: Date[],
    hours: boolean = true
  ): StartAndEndTime {
    if (!time) {
      return {
        startTime: "",
        endTime: "",
      };
    }
    return hours
      ? {
          startTime: this.dateTimeUtilnohms(time[0]),
          endTime: this.dateTimeUtilnohms(time[1]),
        }
      : { startTime: this.dateUtil(time[0]), endTime: this.dateUtil(time[1]) };
  }

  public static animation(dom: HTMLElement) {
    requestAnimationFrame(() => {
      if (dom.scrollHeight - dom.scrollTop === dom.clientHeight) {
        dom.scrollTop = 0;
      }
      // if (dom.scrollTop === 0) {
      //     flag = false;
      // }
      dom.scrollTop += 1;

      this.animation(dom);
    });
  }

  public static getDay(day: number) {
    const today = new Date();

    const targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;

    today.setTime(targetday_milliseconds); //注意，这行是关键代码

    const tYear = today.getFullYear();
    let tMonth: string | number = today.getMonth();
    let tDate: string | number = today.getDate();
    tMonth = Util.fillZero(tMonth + 1);
    tDate = Util.fillZero(tDate);
    return tYear + "-" + tMonth + "-" + tDate;
  }

  public static fmoney(s: string, n: number) {
    n = n >= 0 && n <= 20 ? n : 2;
    if (n === 0) {
      s = parseFloat((s + "").replace(/[^\d\.-]/g, "")) + "";
    } else {
      s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
    }
    let l = s.split(".")[0].split("").reverse();
    let r = n === 0 ? "" : s.split(".")[1];
    let t: string = "";
    for (let i = 0; i < l.length; i++) {
      t += l[i] + ((i + 1) % 3 === 0 && i + 1 !== l.length ? "," : "");
    }
    return n === 0
      ? t.split("").reverse().join("")
      : t.split("").reverse().join("") + "." + r;
  }
  public static fmoney2(s: string) {
    // if (s === '0') {
    //     return  '0';
    // }

    const wan = s.length - 4 <= 0 ? "" : s.slice(0, s.length - 4) + "万";
    return wan + s.slice(s.length - 4, s.length) + "元";
  }

  //防抖

  /**
   * @param func 需要包装的函数
   * @param delay 延迟时间，单位ms
   * @param immediate 是否默认执行一次(第一次不延迟)
   */
  public debounce(
    func: Function,
    delay: number,
    immediate: boolean = false
  ): Function {
    let timer: number | undefined;

    return (...args: any) => {
      if (immediate) {
        func.apply(this, args); // 确保引用函数的指向正确，并且函数的参数也不变
        immediate = false;
        return;
      }
      clearTimeout(timer);
      timer = setTimeout(() => {
        console.log("防抖中");
        func.apply(this, args);
      }, delay);
    };
  }

  //验证手机号
  public static checkMobile(date: string): boolean {
    // 开头的"1"代表第一位为数字1，"[3-9]"代表第二位可以为3、4、5、6、7、8、9其中之一，"\\d{9}"代表后面是9位数字
    const reg = new RegExp(
      "^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\\d{8}$"
    );
    // 字符串变量的matches方法返回正则表达式对该串的检验结果，true表示符合字符串规则，false表示不符合规则
    if (reg.test(date)) {
      return true;
    } else {
      return false;
    }
  }

  // 获取本月时间
  public getCurrentMonth() {
    // if(value==''|| value==undefined){
    //     return value
    // }
    // if(value.length==10){
    //     value = value *1000
    // }
    // let nowdays = new Date(value)
    let nowdays = new Date();
    let year = nowdays.getFullYear();
    let month: any = nowdays.getMonth() + 1;

    if (month < 10) {
      month = "0" + month;
    }

    let yDate = new Date(year, month, 0);

    let startDateTime = year + "-" + month + "-01"; //上个月第一天
    let endDateTime = year + "-" + month + "-" + yDate.getDate(); //上个月最后一天

    return [startDateTime, endDateTime];
  }
}



// 获取excelJSON数据结构
export function getExcelJSONDataByList(list: any[], sortKey: string[], map2ch: any) {
  const newList = list.map((eachItem) => {
    const newItem: any = {};

    for (const key of sortKey) {
      const val = eachItem[key];

      if (val !== null || val !== undefined) {
        const chKey = map2ch[key];

        newItem[chKey] = val;
      }
    }

    return newItem;
  });


  console.log(newList, 'newList getExcelJSONDataByList')
  return newList;
}

//  获取 可以暴露的 API 接口数据结构

export function getPageAPIs(fn: any) {
  if (typeof fn != 'function') {
    throw new TypeError(`fn is not Function`)
  }

  const ins = new fn()

  // console.log(ins, 'ins')

  const apiUrlMaps = ins.apiUrls;
  const apiList: any[]  = []

  for (const [_, pageApiUrls] of apiUrlMaps) {
    if (!pageApiUrls.hidden) {
      apiList.push({
        ...pageApiUrls
      })
    }
  }

  return apiList
}

/** 3d 饼图的默认配置 */
const default3DPieOption = {
  alpha: 30,
  beta: 60,
  distance: 260,
  top: 0,
  left: -25,
  emptyBoxHeight: 0,
  maxLimitBoxHeight: 95,
}

/** 获取 3d 饼图 配置项 根据平面饼图的数据 */
export function get3DPieOption(pieData: any[], pie3Doption: any = default3DPieOption) {
  const {
    alpha = 30,
    beta = 60,
    distance = 260,
    top = 0,
    left = -20,
    emptyBoxHeight = 0,

    _selected = null,
    maxLimitBoxHeight = 95
  } = Object.assign(default3DPieOption, {
    ...pie3Doption
  })
  // internalDiameterRatio:透明的空心占比
  const series = [];
  let sumValue = 0;
  let startValue = 0;
  let endValue = 0;
  let k = 1;
  pieData.sort((a, b) => {
    return b.value - a.value;
  });

  // 为每一个饼图数据，生成一个 series-surface 配置
  for (let i = 0; i < pieData.length; i++) {
    if (_selected === null || _selected[pieData[i].name]) {
      console.log(_selected, '_selected')
      sumValue += pieData[i].value;
    }
    const seriesItem: any = {
      name: typeof pieData[i].name === "undefined" ? `series${i}` : pieData[i].name,
      type: "surface",
      parametric: true,
      wireframe: {
        show: false,
      },
      pieData: pieData[i],
      pieStatus: {
        selected: false,
        hovered: false,
        k: k,
      },
      radius: "50%",
      center: ["10%", "10%"],
    };

    if (typeof pieData[i].itemStyle != "undefined") {
      const itemStyle: any = {};
      typeof pieData[i].itemStyle.color != "undefined" ? (itemStyle.color = pieData[i].itemStyle.color) : null;
      typeof pieData[i].itemStyle.opacity != "undefined"
        ? (itemStyle.opacity = pieData[i].itemStyle.opacity)
        : null;
      seriesItem.itemStyle = itemStyle;
    }
    series.push(seriesItem);
  }

  const surfaceSeries = [
    ...DeepLoop.deepClone(series, false)
  ].filter((serItem: any) => (_selected === null) || _selected[serItem.name])

  console.log(surfaceSeries, 'surfaceSeries')


  // 使用上一次遍历时，计算出的数据和 sumValue，调用 getParametricEquation 函数，
  // 向每个 series-surface 传入不同的参数方程 series-surface.parametricEquation，也就是实现每一个扇形。
  for (let i = 0; i < surfaceSeries.length; i++) {
    endValue = startValue + surfaceSeries[i].pieData.value;
    surfaceSeries[i].pieData.startRatio = startValue / sumValue;
    surfaceSeries[i].pieData.endRatio = endValue / sumValue;
    surfaceSeries[i].parametricEquation = get3DPieParametricEquation(
      surfaceSeries[i].pieData.startRatio,
      surfaceSeries[i].pieData.endRatio,
      false,
      false,
      k,
      surfaceSeries[i].pieData.value
    );
    startValue = endValue;
  }
  const boxHeight = Math.min(maxLimitBoxHeight, getEachtPieHeight3D(surfaceSeries, 30) || emptyBoxHeight); //通过传参设定3d饼/环的高度，26代表26px
  // 准备待返回的配置项，把准备好的 legendData、series 传入。

  for (let i = 0, len = series.length; i < len; i++) {
    const serItem = series[i]

    const newSurFaceSerItm: any = surfaceSeries.find((surFaceSerItm: any) => surFaceSerItm.name == serItem.name)

    if (newSurFaceSerItm) {
      series[i] = {
        ...DeepLoop.deepClone(newSurFaceSerItm, false)
      }
    }
  }


  console.log(series, 'series')

  console.log(boxHeight, 'boxHeight')
  const option = {
    // 引导线配置
    // labelLine: {
    //   show: true,
    //   lineStyle: {
    //     color: "#fff",
    //     normal: {},
    //   },
    // },
    label: {
      show: true,
      position: "inside",
      formatter: function (params: any) {
        // console.log(params, 'params')
        return `{d|${params.percent.toFixed(2)}}{c|${"%"}}`;
      },
      rich: {
        d: {
          fontSize: 16,
          lineHeight: 16,
          // fontFamily: "Source Han Sans",
          fontWeight: "bold",
          color: "#282828",
        },
        // b: {
        //   fontSize: 18,
        //   color: "#fff",
        // },
        c: {
          fontSize: 14,
          lineHeight: 14,
          color: "#282828",
        },
      },
    },
    // 提示框
    // tooltip: {
    //   position: "right", // 将提示框显示在鼠标右侧
    //   textStyle: { color: "#fff", fontSize: 14 },
    //   borderWidth: 1,
    //   borderColor: "#1495F4",
    //   backgroundColor: "rgba(20, 149, 244, 0.5)", // 提示框背景颜色
    //   boxShadow: "0 0 3px rgba(0, 0, 0, 0.3)", // 提示框阴影
    //   extraCssText: "box-shadow: inset 0px 0px 10px 0px rgba(1, 30, 18, 0.302);",
    //   // 格式化提示框，添加单位
    //   formatter: (params: any) => {
    //     if (params.seriesName !== "mouseoutSeries" && params.seriesName !== "pie2d") {
    //       let bfb = 0;
    //       if (this.pieDataFlag) {
    //         let findItem = pieData.find((item) => item.name === params.seriesName);
    //         bfb =  findItem.value;
    //       }
    //       const unit = ["万个", "万户"];
    //       const format = unit.includes(this.unit) ? 2 : 0;
    //       return (
    //         "<div style='color: #fff''>" +
    //         `${params.seriesName}<br/>` +
    //         `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${params.color};"></span>` +
    //         `${formatNumber(bfb, format)}${this.unit}` +
    //         "</div>"
    //       );
    //     }
    //   },
    // },
    xAxis3D: {
      min: -1,
      max: 1,
    },
    yAxis3D: {
      min: -1,
      max: 1,
    },
    zAxis3D: {
      min: -1,
      max: 1,
    },
    grid3D: {
      show: false,
      boxHeight: boxHeight, //圆环的高度
      left: left,
      top: top, //3d饼图的位置
      viewControl: {
        //3d效果可以放大、旋转等，请自己去查看官方配置
        alpha: alpha, //角度
        // 饼块开始得角度
        beta: beta || 60,
        distance: distance, //调整视角到主体的距离，类似调整zoom
        rotateSensitivity: 0, //设置为0无法旋转
        zoomSensitivity: 0, //设置为0无法缩放
        panSensitivity: 0, //设置为0无法平移
        // autoRotate: true //自动旋转
      },
    },
    series: series,
  };
  
  return option
}

//获取3d饼图的最高扇区的高度
function getEachtPieHeight3D(series: any[], height: number) {
  series.sort((a, b) => {
    return b.pieData.value - a.pieData.value;
  });
  return series.length > 0 ? (height * 25) / series[0].pieData.value : 0;
}


// 生成扇形的曲面参数方程，用于 series-surface.parametricEquation
function get3DPieParametricEquation(startRatio: any, endRatio: any, isSelected: any, isHovered: any, k: any, h: any) {
  // 计算
  let midRatio = (startRatio + endRatio) / 2;
  let startRadian = startRatio * Math.PI * 2;
  let endRadian = endRatio * Math.PI * 2;
  let midRadian = midRatio * Math.PI * 2;
  // 如果只有一个扇形，则不实现选中效果。
  if (startRatio === 0 && endRatio === 1) {
    isSelected = true;
  }
  // 通过扇形内径/外径的值，换算出辅助参数 k（默认值 1/3）
  k = typeof k !== "undefined" ? k : 1 / 3;
  // 计算选中效果分别在 x 轴、y 轴方向上的位移（未选中，则位移均为 0）
  let offsetX = isSelected ? Math.cos(midRadian) * 0.1 : 0;
  let offsetY = isSelected ? Math.sin(midRadian) * 0.1 : 0;
  // 计算高亮效果的放大比例（未高亮，则比例为 1）
  let hoverRate = isHovered ? 1.05 : 1;
  // 返回曲面参数方程
  return {
    u: {
      min: -Math.PI,
      max: Math.PI * 3,
      step: Math.PI / 32,
    },
    v: {
      min: 0,
      max: Math.PI * 2,
      step: Math.PI / 20,
    },
    x: function (u: any, v: any) {
      if (u < startRadian) {
        return offsetX + Math.cos(startRadian) * (1 + Math.cos(v) * k) * hoverRate;
      }
      if (u > endRadian) {
        return offsetX + Math.cos(endRadian) * (1 + Math.cos(v) * k) * hoverRate;
      }
      return offsetX + Math.cos(u) * (1 + Math.cos(v) * k) * hoverRate;
    },
    y: function (u: any, v: any) {
      if (u < startRadian) {
        return offsetY + Math.sin(startRadian) * (1 + Math.cos(v) * k) * hoverRate;
      }
      if (u > endRadian) {
        return offsetY + Math.sin(endRadian) * (1 + Math.cos(v) * k) * hoverRate;
      }
      return offsetY + Math.sin(u) * (1 + Math.cos(v) * k) * hoverRate;
    },
    z: function (u: any, v: any) {
      if (u < -Math.PI * 0.5) {
        return Math.sin(u);
      }
      if (u > Math.PI * 2.5) {
        return Math.sin(u) * h * 0.1;
      }
      return Math.sin(v) > 0 ? 1 * h * 0.1 : -1;
    },
  };
}


/** 中国地图图标默认配置 */
const defaultChinaMapOption = {
  zoom: 1.25,
}

/** 获取中国地图图表 配置项 */
export function getChinaMapEchartOption(pinDotData: any[], {
  zoom = 1.25
} = defaultChinaMapOption) {

  const curMonth = dayjs().format('YYYY-MM')

  const option = {
    backgroundColor: "#fff",
    tooltip: {
      trigger: 'item'
    },
    geo: { // 地图 范围 以及 相关样式
      map: "china",
      aspectScale: .75,
      zoom: zoom,
      roam: !1,
      itemStyle: {
        areaColor: '#13995A',
        // normal: {
        //   areaColor: {
        //     type: "radial",
        //     x: .5,
        //     y: .5,
        //     r: .8,
        //     colorStops: [{
        //         offset: 0,
        //         color: "#13995A"
        //     }, {
        //         offset: 1,
        //         color: "#13995A"
        //     }],
        //     globalCoord: !0
        //   },
          // shadowColor: "rgb(58,115,192)",
          // shadowOffsetX: 10,
          // shadowOffsetY: 11
        // },
      },
      emphasis: {
        itemStyle: {
          areaColor: "#13995A",
          borderWidth: 0,
          color: "#FEFEFE",
          label: {
              show: !1
          }
        }
      },
      regions: [{
        name: "南海诸岛",
        itemStyle: {
          areaColor: "#13995A",
          borderColor: "#231916",
          opacity: 0,
          label: {
            show: false,
            color: "#009cc9"
          }
          
        }
      }]
    },
    series: [
      { // 中国地图 样式 
        type: "map",
        roam: !1,
        mapType: "china",
        label: {
          show: !0,
          color: "#FEB100",
          // textStyle: {
          //   color: "#FEB100"
          // },
          // emphasis: {
          //   textStyle: {
          //     color: "#FEB100"
          //   }
          // }
        },
        itemStyle: {
          borderColor: "#FEFEFE",
          borderWidth: "1",
          // shadowColor: "#23C6CE",
          // shadowBlur: 50,
          // shadowOffsetX: -10,
          // shadowOffsetY: -5,
          areaColor: "#13995A"
        },
        select: {
          disabled: true,
        },
        emphasis: {
          // disabled: true,
          label: {
            color: "#FEB100"
          },
          itemStyle: {
            borderColor: '#FEB100',
            areaColor: "#13995A"
          }
        },
        tooltip: {
          // position: ["0%", '0%']
          extraCssText: 'display: none;'
        },
        zoom: zoom,
        map: "china"
      },
      { // pin  dot  地图标点 样式
        type: "effectScatter",
        coordinateSystem: "geo",
        showEffectOn: "render",
        zlevel: 1,
        rippleEffect: {
          period: 4,
          scale: 4,
          brushType: "stroke"
        },
        // hoverAnimation: !0,

        // encode: {
        //   itemName: 'effectDot',
        //   value: ''
        // },
        label: {
          formatter: "",
          position: "right",
          offset: [-2, 0],
          show: !0
        },
        itemStyle: {
          color: "#FEB100",
          shadowBlur: 10,
          shadowColor: "#333"
        },
        tooltip: {
          position: 'top',
          backgroundColor: 'rgba(255, 255, 255, 0.90)',
          borderColor: '#FEB100',
          formatter: function(params: any) {
            // console.log(params, 'params')

            const {
              data = {}
            } = params

            const {
              name,
              total
            } = data

            return `${curMonth}<br />${name}：${total}`
          },
          
        },
        symbolSize: 10,
        data: pinDotData
      },
      // {
      //   type: "lines",
      //   zlevel: 2,
      //   effect: {
      //     show: !0,
      //     period: 4,
      //     trailLength: .4,
      //     symbol: "arrow",
      //     symbolSize: 5
      //   },
      //   lineStyle: {
      //     normal: {
      //         color: "#1DE9B6",
      //         width: 1,
      //         opacity: .1,
      //         curveness: .3
      //     }
      //   }
      // },
      // {
      //   type: "scatter",
      //   coordinateSystem: "geo",
      //   zlevel: 2,
      //   rippleEffect: {
      //       period: 4,
      //       brushType: "stroke",
      //       scale: 4
      //   },
      //   label: {
      //       normal: {
      //           show: !1,
      //           position: "right",
      //           color: "#0f0",
      //           formatter: "{b}",
      //           textStyle: {
      //               color: "#0f0"
      //           }
      //       },
      //       emphasis: {
      //           color: "#f60"
      //       }
      //   },
      //   symbol: "pin",
      //   symbolSize: 50,
      //   data: [{
      //       name: "郑州",
      //       value: "113.631349, 34.753488"
      //   }]
      // }
    ]
  };

  return option
}